<div class="header">
  <app-title
    [title]="'Períodos de prioridad'"
    [subtitle]="
      'Gestiona los períodos de prioridad para las solicitudes de vacaciones.'
    "
  ></app-title>
  <div class="top restaurant">
    <div class="boton">
      <button
        class="b1"
        mat-button
        routerLink="/home/vacations/priority-periods/add"
      >
        Nuevo período
      </button>
    </div>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>

<div class="content">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    class="mat-elevation-z8 table"
  >
    <!-- Exercise Column -->
    <ng-container matColumnDef="exercise">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>EJERCICIO</th>
      <td mat-cell *matCellDef="let period">
        <button mat-flat-button id="button">
          <span style="font-size: 16px">{{
            period.exercise_details?.name || period.exercise
          }}</span>
        </button>
      </td>
    </ng-container>

    <!-- Min Years Worked Column -->
    <ng-container matColumnDef="min_years_worked">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>AÑOS MÍNIMOS</th>
      <td mat-cell *matCellDef="let period">
        <span style="font-size: 16px">{{ period.min_years_worked }}</span>
      </td>
    </ng-container>

    <!-- Start Date Column -->
    <ng-container matColumnDef="start_date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>FECHA INICIO</th>
      <td mat-cell *matCellDef="let period">
        <span style="font-size: 16px">{{ period.start_date }}</span>
      </td>
    </ng-container>

    <!-- End Date Column -->
    <ng-container matColumnDef="end_date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>FECHA FIN</th>
      <td mat-cell *matCellDef="let period">
        <span style="font-size: 16px">{{ period.end_date }}</span>
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>ACCIONES</th>
      <td mat-cell *matCellDef="let period">
        <button mat-icon-button (click)="goToPriorityPeriod(period.id, $event)" class="acciones">
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        <button mat-icon-button (click)="deletePriorityPeriod($event, period.id, period.exercise_details?.name || 'Período')" class="acciones">
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
